import {React, useState, useEffect } from "react";
import MuiTable from "../common/MuiTable";
import { FxmsData } from "../../fxms/datas/FxData";
import { UI_3_1_tableRow } from "./helper/UI_3_1.helper";
import { getInloInfo } from "../common/commonMethod";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { getToday, getMonthByDate, getMonthBetween} from "../common/commonMethod";
import { FxOpenButton } from "./../../fxms/inputs/FxOpenButton";

/*설비진단>정비 이력*/
export const UI_3_1 = () => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo),user);
  const opObjCheck = FxmsData.getOpObj("ui-3-1-detail");
  
  const [fetchData, setFetchData] = useState([]);
  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchCompanyInlo, setFetchCompanyInlo] = useState([]);
  const [fetchPlantInlo, setFetchPlantInlo] = useState([]);

  const [selected, setSelected] = useState({
    complexInloNo: user.ugrpNo === 1021||user.ugrpNo === 1024? inlo.complexInloNo : "",
    companyInloNo:user.ugrpNo === 1024? inlo.companyInloNo : "",
    plantInloNo: user.ugrpNo === 1024? inlo.inloNo : "",
    alarmClCd: "",
    startDate: getMonthByDate(-3),
    endDate:  getToday()
  });
  
  const alarmOptions = [
    { label: "알람 전체", value: "" },
    { label: "이상알람", value: "DIAGNOSIS" }, // ALCD_GRP
    { label: "일반알람", value: "OTHER" },     // 
    { label: "정기점검알람", value: "PERIODIC_INSPEC" }// ALCD_GRP 
  ];

  const submitBtnClick = async () => {
    if (selected == null) return;

    if (parseInt(selected.startDate) > parseInt(selected.endDate)) {
      FxWindow.alert("조회 기간이 잘못되었습니다.", true);
      return;
    } else if (
      getMonthBetween(selected.startDate.replace(/-/gi, ""), selected.endDate.replace(/-/gi, "")) > 5*12
    ) {
      FxWindow.alert("최대 5년까지 조회 가능합니다.", true);      
      return;
    }

     const param = {
      mntnStrtDateStart: (selected.startDate).replace(/-/gi, ""), 
      mntnStrtDateEnd: (selected.endDate).replace(/-/gi, ""),      
      alarmClCd: selected.alarmClCd,
      complexInloNo: selected.complexInloNo,
      companyInloNo: selected.companyInloNo,
      plantInloNo: selected.plantInloNo,
    }

    try {
      const uri = "vup/select_3_1";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_3_1 res........", res.data);
      
      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");

      setFetchData(res.data);
    } catch (e) {
      console.log("UI_3_1 fetchData error", e);
    }
  }

  const dataGrid = (
    alarmNo,
    complexName,  // 산단명
    companyName,  // 회사명
    plantName,    // 사업장명
    alarmClCd,    // 알람종류
    facName,      // 설비명
    fpactCnt,        // 조치내용
    fpactStrtDate,     // 실제정비시작일
    fpactEndDate,     // 실제정비종료일
    fpactButton
  ) => {
    return {
      alarmNo,
      complexName,
      companyName,
      plantName,
      alarmClCd,
      facName,
      fpactCnt,
      fpactStrtDate,
      fpactEndDate,
      fpactButton
    };
  };


  const resultRow = fetchData.map(item => {
    return dataGrid(
      item.alarmNo,
      item.complexName,
      item.companyName,
      item.plantName,
      item.alarmClCd,
      item.facName,
      item.fpactCnt,
      item.fpactStrtDate ? item.fpactStrtDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') : '',
      item.fpactEndDate ? item.fpactEndDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') : '',
      <FxOpenButton    // 상세보기 버튼 추가
        key={`${item.alarmNo}-${item.alarmClCd}`}  // key prop 추가
        title={"상세 보기"}
        opObj={opObjCheck}
        selectedData={item}
        className="fpactButton"
        refershGridData={submitBtnClick}
      />
    )
  })

  // complexInloNo가 설정되면 회사 목록을 가져오도록 useEffect 추가
  useEffect(() => {
    if (selected.complexInloNo) {
      selectedComplex(selected.complexInloNo);
    }
  }, [selected.complexInloNo]);

  // companyInloNo가 설정되면 공장 목록을 가져오도록 useEffect 추가
  useEffect(() => {
    if (selected.companyInloNo) {
      selectedCompany(selected.companyInloNo);
    }
  }, [selected.companyInloNo]);

  useEffect(() => {
    console.log("selected ........ ", selected);
  }, [selected])

  useEffect(() => {
    console.log("*** UI_3_1 ***");

    if(user.ugrpNo !== 1021 || user.ugrpNo !== 1024){ //산단      
      getComplexInloData();     
    }

    submitBtnClick();

  }, [inlo,user]);

  useEffect(()=>{
    if (inlo.complexInloNo && user.ugrpNo !== 1024) {
      selectedComplex(inlo.complexInloNo);
    }
  },[selected.alarmClCd])


  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList"
    try {
      const res = await FxmsData.GET(uri);
      setFetchComplexInlo(res.data);             
      console.log("complex List >> ", res.data);       
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  }

const selectedComplex = async (value) => {
    console.log("선택된 산단번호 ::", value);
    setSelected((prev) => ({ ...prev, complexInloNo: value }));

    if(value === "" || !value){
      setFetchCompanyInlo([]);
      setSelected((prev) => ({ ...prev, companyInloNo: "" }));
      setSelected((prev) => ({ ...prev, plantInloNo: "" }));
      setSelected((prev) => ({ ...prev, facNo: "" }));   
    } else {
      const param = {
        energy: selected.engId,
        sourceSink: selected.method ==='cons'? 'SINK':'SOURCE',
        complexInloNo: value,
      }
        const uri = "vup/getCompanyInloListNew";
      try {
        const res = await FxmsData.GET(uri,param);       
        setFetchCompanyInlo(res.data); 
        console.log("company List >>", res.data); 
      } catch (e) {
        console.log("getCompanyInloList error.... ", e);
      }
    }
    setFetchPlantInlo([]); // 산단을 변경하면 plantInlo를 초기화
    console.log("selected ........", selected);
  }

  const selectedCompany = async (value) => {
    console.log("선택된 회사번호 :: ", value);
    setSelected((prev) => ({ ...prev, companyInloNo: value }));

    if(value===""){
      setFetchPlantInlo([]);
      setSelected((prev) => ({ ...prev, plantInloNo: value }));
      setSelected((prev) => ({ ...prev, facNo: value }));        
    }else{
      const uri = "vup/getPlantInloList/" + value;
      try {
        const res = await FxmsData.GET(uri);
        setFetchPlantInlo(res.data);
        
        console.log("plant List >>", res.data);
      } catch (e) {
        console.log("getPlantInloList error.... ", e);
      }
    }     
  }

  const onChangeDatas = (event) => {
    const { value, name } = event.target;       
    
    setSelected((prev) => {
      return { ...prev, [name]: value };
    })
  }




  return (
    <>
    <div className="predict">
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
        <label className="FxLabelSearch"></label>
          {user.ugrpNo === 1021 || user.ugrpNo === 1024 ?
          <select className="FxSelectSearch" value={inlo.complexInloNo}>
           <option value={inlo.complexInloNo}> {inlo.complexInloName} </option>
           </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedComplex(e.target.value)}>
                <option value="">산업단지 전체</option>
                {fetchComplexInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                    {item.inloName}
                  </option>
                ))}
            </select>
            }         
         <label className="FxLabelSearch"></label>  
         {user.ugrpNo === 1024 ?
          <select className="FxSelectSearch" value={inlo.companyInloNo}>
           <option value={inlo.companyInloNo}> {inlo.companyInloName} </option>
           </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedCompany(e.target.value)}>
                <option value="">회사 전체</option>
                {fetchCompanyInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="companyInloNo">
                    {item.inloName}
                  </option>
                ))}
            </select>            }                   
          
          <label className="FxLabelSearch"></label> 
          {user.ugrpNo === 1024 ?
              <select className="FxSelectSearch" value={inlo.inloNo}>
              <option value={inlo.inloNo}> {inlo.inloName} </option>
              </select> 
              :
             <select className="FxSelectSearch" name="plantInloNo" onChange={onChangeDatas}>
              <option value="">사업장 전체</option>
              {fetchPlantInlo?.map((item) => (
                <option key={item.inloNo} value={item.inloNo} name="plantInloNo">
                  {item.inloName}
                </option>
              ))}
            </select>  
            }                
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="alarmClCd" onChange={onChangeDatas}>           
            {alarmOptions.map((item, index) => (
              <option key={index} value={item.value} name="alarmClCd">{item.label}</option>
            ))}
          </select>
        </div>
        <div className="FxFilterRight">
          <input className="FxDate" type="date" name="startDate" value={selected.startDate} onChange={onChangeDatas} />
          <label className="FxLabelSearch">~</label>
          <input className="FxDate" type="date" name="endDate" value={selected.endDate} onChange={onChangeDatas} />
          <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick}/>
        </div>
      </div>
      <div className="FxCrudDataGrid">  
        정비이력   
        <div className="FxMuiTable">
          <MuiTable
            tableRowDataList={UI_3_1_tableRow}
            rows={resultRow}
            menuFullName='설비진단/정비이력'
          />
        </div>
      </div>
    </div>
    </>
  )

}